import React from 'react'
import InputRowReadOnly from '../elements/InputRowReadOnly'
import store from '../store'

const InputRowPaymentMethod = (props) => {
    return (
        <InputRowReadOnly
            label='Current payment method'
            value={props.displayPaymentVia ? props.displayPaymentVia : store.getState().auth.displayPaymentVia}
        />
    )
}

export default InputRowPaymentMethod



// WEBPACK FOOTER //
// ./resources/js/components/InputRowPaymentMethod.js